<div class="filter-group" data-group-visibility-id="showMyJewelleryFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showMyJewelleryFilters" (click)="filter.groupVisibility.showMyJewelleryFilters = !filter.groupVisibility.showMyJewelleryFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Favourite Jewellery" [activeRules]="activeSpecialRules.jewelleryExceptions">
          Select the jewels you are looking for for your character(s), optionally set minimal conditions, and configure which Variants you're interested in and how they should be highlighted using the <span class="icon icon-equalizer"></span> button.
          <br/><br/>Rules with a <span class="equipment-filter-from-preset-example">gold line</span> to the left were automatically generated from your Class or Progress Preset, and might get changed along with presets.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showMyJewelleryFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showMyJewelleryFilters">

      @for (jewellery of filter.jewelleryFilters; track $index) {
        <app-jewellery-filter
          [jewellery]="jewellery"
          [index]="$index"
          (remove)="removeJewelleryType($event)">
        </app-jewellery-filter>
      }

      <div class="filter filter-padded">
        <button type="button" class="btn clear-btn" style="width: 100%;" (click)="addJewelleryType()">
          Add Jewellery Type
        </button>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>
